import React from 'react';
import { motion } from 'framer-motion';
const audiences = [{
  emoji: '🌱',
  title: 'Principiantes',
  description: 'Personas que sienten el llamado a la sanación energética y quieren comenzar con una base sólida, sin conocimientos previos requeridos.'
}, {
  emoji: '💆',
  title: 'Terapeutas Holísticos',
  description: 'Profesionales del bienestar que quieren incorporar el Reiki a su práctica existente con un enfoque estructurado y profesional.'
}, {
  emoji: '✨',
  title: 'Buscadores de Crecimiento',
  description: 'Personas en un camino de autoconocimiento que quieren profundizar en el trabajo energético para su propio desarrollo y el de otros.'
}];
export function AudienceSection() {
  return <section className="py-24 relative overflow-hidden" data-id="element-2">
      {/* Gradient Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#1e1254] via-[#2e1065] to-[#0f0a2e]" data-id="element-3" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-4">
        <div className="text-center mb-16" data-id="element-5">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-6">
            ¿Para Quién es Este Sistema?
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-7">
          {audiences.map((item, i) => <motion.div key={i} className="bg-white/5 backdrop-blur-sm border border-white/10 p-8 rounded-xl text-center hover:bg-white/10 transition-colors" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} data-id="element-8">
              <div className="text-5xl mb-6" data-id="element-9">{item.emoji}</div>
              <h3 className="text-2xl font-bold text-white mb-4 font-heading" data-id="element-10">
                {item.title}
              </h3>
              <p className="text-purple-100 font-light leading-relaxed" data-id="element-11">
                {item.description}
              </p>
            </motion.div>)}
        </div>

        <motion.p className="text-center text-purple-200 mt-12 text-lg italic" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5
      }} data-id="element-12">
          Si te identificas con alguno de estos perfiles, este sistema fue
          creado para ti.
        </motion.p>
      </div>
    </section>;
}